module.exports = __webpack_public_path__ + "static/media/green-footer.cbcd79d5.png";